import TabsNav from '@/primitives/tabs.tsx';
import type { OnboardImportModel } from '../../types/onboard-import.type.ts';
import AvailabilitySlotImportTable from './availability-slot-import-table.tsx';
import MeetingImportTable from './meeting-import-table.tsx';
import RepImportTable from './rep-import-table.tsx';
import StaffImportTable from './staff-import-table.tsx';

const tabs = [
  { label: 'Representatives', key: 'reps' },
  { label: 'Staff Members', key: 'staff' },
  { label: 'Meetings', key: 'meetings' },
  { label: 'Availability Slots', key: 'slots' },
];

const OnboardImportTabs = ({ onboardImport }: { onboardImport: OnboardImportModel }) => {
  const content = {
    reps: () => (
      <RepImportTable lineItems={onboardImport?.onboardRepresentativeImportLineItems ?? []} />
    ),
    staff: () => <StaffImportTable lineItems={onboardImport?.onboardStaffImportLineItems ?? []} />,
    meetings: () => (
      <MeetingImportTable lineItems={onboardImport?.onboardMeetingImportLineItems ?? []} />
    ),
    slots: () => (
      <AvailabilitySlotImportTable
        lineItems={onboardImport?.onboardAvailabilitySlotImportLineItems ?? []}
      />
    ),
  };

  return <TabsNav content={content} tabs={tabs} />;
};

export default OnboardImportTabs;
